import type { RouteObject } from 'react-router';
import { useSession } from '../../lib/session.tsx';
import { EntetePage, Panneau } from '../../components/ui.tsx';

function PageTransparence() {
  const { etat } = useSession();
  const ia = etat?.ia;
  return (
    <div className="pile-l" style={{ maxWidth: '75ch' }}>
      <EntetePage titre="Transparence sur l’intelligence artificielle" />
      <Panneau titre="État actuel de cette installation">
        <div className="pile">
          {ia?.disponible ? (
            <>
              <p>Un service d’assistance par intelligence artificielle est configuré : <strong>{ia.fournisseur}</strong>
                {ia.modele ? <> (modèle <span className="mono">{ia.modele}</span>)</> : null}{ia.local ? ', exécuté sur l’infrastructure interne' : ', hébergé par un prestataire externe'}.</p>
              <p>Envoi d’extraits de documents clients à ce service : <strong>{ia.documentsClientsAutorises ? 'autorisé par la configuration' : 'non autorisé'}</strong>.</p>
            </>
          ) : (
            <p>Aucun service d’intelligence artificielle n’est activé. Les détections (exigences d’un dossier, contrôles proposés) reposent sur des
              règles métier explicites, dont la règle appliquée est indiquée à côté de chaque résultat.</p>
          )}
        </div>
      </Panneau>
      <Panneau titre="Ce que fait l’assistance lorsqu’elle est activée">
        <ul className="pile" style={{ paddingLeft: 20, margin: 0 }}>
          <li>Elle propose des contrôles, hypothèses ou exigences, toujours marqués comme proposés par l’assistance et accompagnés de leurs sources.</li>
          <li>Elle lit les photos (plaque signalétique, afficheur d’un appareil) et les pages scannées des documents lorsque l’envoi des documents
            est autorisé : les valeurs lues sont marquées « Lu sur la photo — à confirmer » et ne sont enregistrées qu’après confirmation ;
            le texte des pages scannées est marqué « Texte lu automatiquement — à vérifier sur l’image de la page ».</li>
          <li>Import d’un devis ou d’une commande en PDF : un PDF avec une couche texte est lu sans intelligence artificielle. Un PDF scanné n’est
            lu par l’assistance que si l’administrateur l’a autorisé et à la demande de l’utilisateur ; les lignes transcrites sont marquées
            « Lu par l’assistance IA — à vérifier sur le PDF », TRAME refait tous les contrôles au centime et bloque l’import en cas d’écart.</li>
          <li>Mémoire technique : le mémoire est assemblé par des règles écrites, sans intelligence artificielle. À la demande, l’assistance peut proposer une
            meilleure forme pour une section ; la proposition est rejetée en entier si elle ajoute un nombre, une norme ou une marque absents du texte
            d’origine, et elle n’est retenue que si la personne qui rédige l’accepte. Le document porte alors un marquage à la fin de chaque section
            reformulée et une mention en fin de document.</li>
          <li>Elle ne prend aucune décision : validation technique, décisions contractuelles et émission d’un devis restent humaines.</li>
          <li>Elle n’envoie aucune commande à un automate ou à une installation.</li>
          <li>Les instructions éventuellement présentes dans un document importé sont traitées comme des données, jamais comme des ordres.</li>
          <li>Si le contenu produit (rapport, devis) est transmis à un tiers, l’entreprise qui le diffuse en reste responsable et doit signaler les contenus générés par IA qu’il contient.</li>
        </ul>
      </Panneau>
      <p className="petit discret">Cadre : règlement (UE) 2024/1689, article 50 (obligations de transparence). Pour toute question : l’administrateur de votre société.</p>
    </div>
  );
}

function PageConfidentialite() {
  const { etat } = useSession();
  return (
    <div className="pile-l" style={{ maxWidth: '75ch' }}>
      <EntetePage titre="Confidentialité des données" />
      <Panneau titre="Où sont vos données">
        <ul className="pile" style={{ paddingLeft: 20, margin: 0 }}>
          <li>Base de données : {etat?.base === 'postgres' ? 'PostgreSQL de l’installation' : 'base embarquée (installation de développement ou de démonstration)'}.</li>
          <li>Fichiers : stockage {etat?.stockage === 's3' ? 'objet privé compatible S3' : 'privé sur le serveur de l’installation'}, jamais exposés publiquement.</li>
          <li>Chaque donnée appartient à une organisation ; les accès sont contrôlés sur le serveur, site par site.</li>
          <li>Mots de passe, clés KNX et identifiants d’installation sont chiffrés à part et exclus de la recherche documentaire.</li>
          <li>Aucun service externe de transcription, d’analyse ou de mesure d’audience n’est activé sans configuration explicite.</li>
        </ul>
      </Panneau>
    </div>
  );
}

function PageMentions() {
  return (
    <div className="pile-l" style={{ maxWidth: '75ch' }}>
      <EntetePage titre="Mentions légales" />
      <Panneau>
        <div className="pile">
          <p>TRAME est un nom de travail. L’éditeur, l’hébergeur et le responsable de publication de cette installation sont à renseigner par
            l’entreprise exploitante avant toute mise en production.</p>
          <p>Conception et développement : VLT GRAPHIQUE.</p>
        </div>
      </Panneau>
    </div>
  );
}

export const routesLegal: RouteObject[] = [
  { path: 'transparence', element: <PageTransparence /> },
  { path: 'confidentialite', element: <PageConfidentialite /> },
  { path: 'mentions-legales', element: <PageMentions /> },
];
